export default "__VITE_ASSET__c6e14ac2__"